import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs';
import { AddressTypes } from '@innogy/common-ui/forms';
import { concatLatestFrom } from '@ngrx/operators';

import {
  onHeatpumpsFunnelNavigationAction,
  selectHeatpumpsFunnelSettings,
} from '../heatpumps-funnel';
import { heatpumpsWizardFormSubmitAction } from './heatpumps-wizard.actions';
import {
  prefillHeatpumpsOrderFormAddressStateAction,
  resetHeatpumpsOrderFormAction,
} from '../heatpumps-order-form';

@Injectable()
export class HeatpumpsWizardEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly funnelSettings$ = this.store.select(
    selectHeatpumpsFunnelSettings
  );

  public readonly submitHeatpumpsWizardFormSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(heatpumpsWizardFormSubmitAction),
      concatLatestFrom(() => this.funnelSettings$),
      mergeMap(([address, funnelSettings]) => [
        resetHeatpumpsOrderFormAction(),
        onHeatpumpsFunnelNavigationAction({
          page: funnelSettings.questionnairePage,
        }),
        prefillHeatpumpsOrderFormAddressStateAction({
          payload: {
            addressType: AddressTypes.ADDRESS,
            postalCode: address.postcode,
            communicationNumber: Number(address.houseNumber),
            houseNumberAddition: address.houseNumberAddition,
            city: address.city,
            street: address.street,
          },
        }),
      ])
    )
  );
}
